import { render, staticRenderFns } from "./DeleteModel.vue?vue&type=template&id=73eb42dd&scoped=true&"
import script from "./DeleteModel.vue?vue&type=script&lang=js&"
export * from "./DeleteModel.vue?vue&type=script&lang=js&"
import style0 from "./DeleteModel.vue?vue&type=style&index=0&id=73eb42dd&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73eb42dd",
  null
  
)

export default component.exports